<template>
  <div v-if="detail">
    <div class="d_title" v-if="$conFun.clientWidth() > 768">{{ detail.arttitle }}</div>
    <div class="d_title" style="width:auto" v-else>{{ detail.arttitle }}</div>
    <div class="d_date">{{ detail.CreatedOn }}</div>
    <div class="d_detail f18 c3" v-html="detail.content"></div>
  </div>
</template>
<script>
export default {
  props: ["id", "detail"],
};
</script>
<style scoped>
.d_title {
  width: 720px;
  height: 86px;
  font-size: 24px;
  font-family: Source Han Sans CN, Source Han Sans CN-Bold;
  font-weight: 700;
  text-align: left;
  color: #333333;
  line-height: 43px;
  overflow: hidden;
}
.d_date {
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: Normal;
  text-align: left;
  color: #999999;
  line-height: 28px;
  padding: 20px 0;
  border-bottom: 1px solid #eeeeee;
}
.d_detail {
  line-height: 32px;
}
.d_detail p {
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/NewDetail.vue